import * as Toolkit from '../../../toolkit/index';
import * as CubeTree from '../../../cubeTree/index';
import CodiSystem from '../../../codiSystem/index';

function findFreeLayerInsertSubTarget(hoverLayer: CubeId, mousePoint: MousePoint, dragCubes: CubeId[]): CubeId {
    let layerChildren: CubeId[] = CubeTree.findChildCubeIdsWithSkip(hoverLayer, dragCubes);
    let layerChildrenCoordinate: CubePaintCoordinate[] = CodiSystem.getPaintCoordinates(layerChildren);

    if (!layerChildrenCoordinate.length || dragCubes.length > 1) {
        return hoverLayer;
    }

    if (!CubeTree.layerIsSubDrag(hoverLayer)) {
        return hoverLayer;
    }

    for(let i = layerChildrenCoordinate.length - 1; i >= 0; i--) {
        let coordinate: CubePaintCoordinate = layerChildrenCoordinate[i];
        let point: MousePoint = {
            ...mousePoint
        };
        let rect: Rect = {
            left: coordinate.left,
            top: coordinate.top,
            width: coordinate.width,
            height: coordinate.height
        };

        /**
         * 自由放置层板的字码插入对象规则
         *
         * 1. 鼠标点出发范围
         * 2. 拖拽的组件必须是商品
         * 3. 触发对象必须是商品
         */
        if (Toolkit.pointOfRectDirection(point, rect, 0.5) === 'middle'
            && !CubeTree.hasSubGoods(dragCubes[0])
            && CubeTree.isGoods(dragCubes[0])
            && CubeTree.isGoods(coordinate.id)) {
            return coordinate.id;
        }
    }

    return hoverLayer;
}

export {
    findFreeLayerInsertSubTarget
};
